/**
 * Created by gilk on 06/03/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/conversation-sources/brand-app/brandAppActivationView.tmpl");
    var ConnectorModel = require("manager-models/data-sources/conversation-sources/ConnectorModel");
    var Button = require("ui/button/Button");
    var KpContent = require("ui.components/kpContent/kpContent");
    var InputField = require("ui/input-field/InputField");
    var BrandAppAdvantagesView = require("manager-views/data-sources/conversation-sources/brand-app/BrandAppAdvantagesView");

    var BrandAppActivationView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        BrandAppActivationView = Marionette.ItemView.extend({
            template : template,
            className : "brand-app-edit-activation-container conversation-source-edit-activation-container app-install-edit-container-view",
            ui : {
                closeButton: ".button-close",
                instructionsContainer: ".structured-instructions-container",
                learnMore: ".learn-more",
                nameInputContainer: ".app-install-name-container .input-container",
                brandAppLogoUriInputContainer: ".app-install-logo-uri-container .input-container"
            },
            uiComponents : {
                appInstallIconUrl:{
                    type: InputField,
                    options: {
                        el: "view.ui.brandAppLogoUriInputContainer",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        value: "view._getBrandAppLogoName"
                    }
                },
                learnMoreButton:{
                    type: KpContent,
                    options: {
                        container: "view.ui.learnMore",
                        KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                        kpID: "view._getLearnMoreKpId",
                        showKPIcon: true
                    }
                },
                sourceName:{
                    type: InputField,
                    options:{
                        el:"view.ui.nameInputContainer",
                        readonly: true,
                        permutation: InputField.Permutation.B,
                        value: LE.translator.translate("LEManager.dataSources.conversationSources.gallery.brandApp.name")
                    }
                },
                closeButton:{
                    type: Button,
                    options: {
                        el: "view.ui.closeButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        click: "_onCloseClick"
                    }
                },
                advantagesView: {
                    type: BrandAppAdvantagesView,
                    options: {
                        el: "view.ui.instructionsContainer"
                    }
                }
            },
            initialize : function (options) {
                LEManager.logger.debug("BrandAppActivationView:initialize");
                this.channel = LEManager.media.channel("conversationSources");
                this.typeConfiguration = ConnectorModel.SOURCE_TYPE_CONFIGURATION[ConnectorModel.SOURCE_TYPES.BRAND_APP];
                this._bindEvents();
            },
            customTemplateHelpers: function() {
                var videoUrl = this.typeConfiguration.video;
                var showVideo = !_.isEmpty(videoUrl);
                var logo_uri = this.typeConfiguration.logo_uri;
                var description = this._getLongDescription();
                return {
                    showVideo: showVideo,
                    videoUrl: videoUrl,
                    logo_uri: logo_uri,
                    description: description
                };
            },
            _bindEvents: function(){
                this.listenTo(this, "page:closeButtonClick", this._onCloseClick);
            },
            _getLearnMoreKpId: function() {
                return this.typeConfiguration.kp;
            },
            _getLongDescription: function() {
                return LE.translator.translate("LEManager.dataSources.conversationSources.gallery.brandApp.description.full");
            },
            _getBrandAppLogoName: function() {
                var logoUrl = this.typeConfiguration.logo_uri;
                var logoUrlSplit = logoUrl.split("/");
                return logoUrlSplit[logoUrlSplit.length - 1];
            },
            _onCloseClick: function() {
                this.channel.trigger("brandApp:close");
            },
            onClose : function () {
                LEManager.logger.debug("BrandAppActivationView:onClose");
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return BrandAppActivationView;
});
